export interface ExoClickTrackingParams {
  exotracker: string
  exocampaign?: string
}

const STORAGE_KEY = 'exoclick-tracking'

/**
 * Saves ExoClick tracking parameters to localStorage
 */
export function saveExoClickTracking(params: ExoClickTrackingParams): void {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(params))
    }
  } catch (error) {
    console.warn('Failed to save ExoClick tracking params to localStorage:', error)
  }
}

/**
 * Retrieves ExoClick tracking parameters from localStorage
 */
export function getExoClickTracking(): ExoClickTrackingParams | null {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        return JSON.parse(stored) as ExoClickTrackingParams
      }
    }
  } catch (error) {
    console.warn('Failed to retrieve ExoClick tracking params from localStorage:', error)
  }
  return null
}

/**
 * Clears ExoClick tracking parameters from localStorage
 */
export function clearExoClickTracking(): void {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem(STORAGE_KEY)
    }
  } catch (error) {
    console.warn('Failed to clear ExoClick tracking params from localStorage:', error)
  }
}

/**
 * Captures ExoClick tracking parameters from URL search params
 */
export function captureExoClickParamsFromUrl(
  searchParams: URLSearchParams
): ExoClickTrackingParams | null {
  const exotracker = searchParams.get('exotracker')
  const exocampaign = searchParams.get('exocampaign')

  if (exotracker) {
    return {
      exotracker,
      exocampaign: exocampaign || undefined,
    }
  }

  return null
}
